'use client';

import { websiteEnv } from '@/constants/website-env';
import clsx from 'clsx';
import Link from 'next/link';
import HoverPrefetchLink from '../hover-prefetch-link';
import FooterMenuItem from './footer-menu-item';

const FooterMenu = () => {
  return (
    <div className='lg_flex lg_flex-wrap lg_items-start lg_gap-x-[103px] lg_gap-y-5'>
      {configs.map(({ label, children }, i) => {
        return (
          <FooterMenuItem
            key={i}
            label={label}
            dropdown={
              <ul
                className={clsx(
                  'flex flex-col gap-y-[14px] lg_mt-[22px] lg_gap-y-2.5',
                  'py-[15px] pl-[30px] lg_py-0 lg_pl-0',
                  'border-b-1 border-solid border-E7DED5 lg_border-b-[0]',
                )}
              >
                {Array.isArray(children) && children.length > 0
                  ? children.map(({ label, href, prefetch = false }, i) => {
                      const LinkComponent = prefetch ? Link : HoverPrefetchLink;

                      return (
                        <li key={i}>
                          <LinkComponent
                            href={href}
                            className='text-[15px] leading-[22px] text-#403732 lg_hover_underline'
                            prefetch={prefetch}
                          >
                            {label}
                          </LinkComponent>
                        </li>
                      );
                    })
                  : null}
              </ul>
            }
          />
        );
      })}
    </div>
  );
};

const configs = [
  {
    label: 'ABOUT US',
    children: [
      {
        label: 'About AW.Bridal',
        href: '/about-us',
        prefetch: true,
      },
      {
        label: 'AW.Bridal Blog',
        href: 'https://www.awbridal.com/wedding-blog/',
        prefetch: true,
      },
      {
        label: 'Craftsmanship',
        href: '/craftsmanship',
        prefetch: true,
      },
      {
        label: 'Real Wedding',
        href: '/real-wedding',
        prefetch: true,
      },
      {
        label: 'Reviews',
        href: '/reviews',
        prefetch: true,
      },
      {
        label: 'Sitemap',
        href: '/sitemap',
        prefetch: true,
      },
    ],
  },
  {
    label: 'CUSTOMER CARE',
    children: [
      {
        label: 'Contact Us',
        href: '/contact-us',
        prefetch: true,
      },
      {
        label: 'Help & FAQs',
        href: '/faq',
        prefetch: true,
      },
      {
        label: websiteEnv.isUnitedKingdom ? 'Size Guide' : 'Size Charts',
        href: '/size-chart',
        prefetch: true,
      },
      {
        label: websiteEnv.isUnitedKingdom ? 'Shop By Colour' : 'Shop By Color',
        href: '/shop-by-color',
        prefetch: true,
      },
      {
        label: 'Track Your Order',
        href: '/track-your-order-login',
        prefetch: true,
      },
      {
        label: 'Shipping Policy',
        href: '/shipping-policy',
        prefetch: true,
      },
      {
        label: 'Return Policy',
        href: '/return-policy',
        prefetch: true,
      },
      {
        label: 'Payment Method',
        href: '/payment-method',
        prefetch: true,
      },
    ],
  },
  {
    label: 'SERVICES',
    children: [
      {
        label: '12% Student Discount',
        href: '/student-discount',
        prefetch: true,
      },
      {
        label: '12% Nurse Discount',
        href: '/nurse-discount',
        prefetch: true,
      },
      {
        label: 'Free Wedding Guide',
        href: '/free-wedding-guide',
        prefetch: true,
      },
      {
        label: 'Influencer Program',
        href: '/influencer-program',
        prefetch: true,
      },
      {
        label: 'Affiliate Program',
        href: '/affiliate',
        prefetch: true,
      },
      {
        label: 'Wholesale Program',
        href: '/wholesale-program',
        prefetch: true,
      },
      {
        label: 'Wedding Planning',
        href: '/wedding-planners-pro',
        prefetch: true,
      },
      websiteEnv.isUnitedStates
        ? {
            label: 'Scholarship Program',
            href: '/scholarship-program',
            prefetch: true,
          }
        : null,
      {
        label: 'Product Tester',
        href: '/recruit-free-product-tester',
        prefetch: true,
      },
    ].filter(Boolean),
  },
  {
    label: 'SHOP BY CATEGORY',
    children: [
      {
        label: 'Wedding Dresses',
        href: '/wedding-dresses',
      },
      {
        label: 'Bridesmaid Dresses',
        href: '/bridesmaid-dresses',
      },
      {
        label: 'Wedding Guest',
        href: '/wedding-guest-dresses',
      },
      {
        label: 'Mother of Bride Dresses',
        href: '/mother-of-the-bride-dresses',
      },
      {
        label: 'Dresses',
        href: '/dresses',
      },
      websiteEnv.isUnitedStates
        ? {
            label: 'Shoes',
            href: '/wedding-shoes',
          }
        : null,
      websiteEnv.isUnitedStates
        ? {
            label: 'Robes',
            href: '/wedding-bathrobes',
          }
        : null,
      websiteEnv.isUnitedStates
        ? {
            label: 'Gifts & Decor',
            href: '/wedding-gifts-decor',
          }
        : null,
    ].filter(Boolean),
  },
];

export default FooterMenu;
